import React from "react";
import styles from "./loader.module.css";

// @ts-ignore
import { Eclipse } from "react-loading-io";

export default function Loader({ loading, children, className, fullPage, content }:
    { loading: boolean, children?: React.ReactNode, className?: string, fullPage?: boolean, content?: React.ReactNode }
) {
    return (
        <div className={`${className ?? ''}`.trim()}>
            {
                loading
                    ? <div className={`${styles.loaderContainer} ${fullPage ? styles.fullPage : ''}`.trim()}>
                        <Eclipse size={64} />
                        {content ?
                            <div className={styles.loaderContent}>{content}</div> :
                            null}
                    </div>
                    : children
            }
        </div>
    );
}